import React from 'react'
import clsx from 'clsx'
import kebabCase from 'lodash.kebabcase'
import { MarkdownBody } from '@/components/atoms/MarkdownBody/MarkdownBody'
import { RichTextField } from '@/components/organisms/RichTextField/RichTextField'
import { MarkdownContentProps } from './types'
import * as style from './MarkdownContent.module.css'

export function MarkdownContent({ heading, content }: MarkdownContentProps) {
  return (
    <div className="max-w-screen-desktop mx-auto px-32 py-48 font-poppins" id={kebabCase(heading)}>
      {heading && (
        <h1 className="text-headingL-mobile font-bold text-text-dark-900 text-center mb-40 laptop:text-headingL laptop:mb-64">
          {heading}
        </h1>
      )}
      <div className={clsx('text-accent-navy-blue text-bodyL laptop:max-w-4xl laptop:mx-auto', style.content)}>
        {typeof content === 'string' ? <MarkdownBody>{content}</MarkdownBody> : <RichTextField data={content} />}
      </div>
    </div>
  )
}
